import { AboutUsText } from '../../components/common/about-us-text';
import { AboutUs as AboutUsImage } from '../../assets';
import { domainLogo, domainLogoAlt } from '../../components/domain-logo';
import { PoweredByAffiliation } from '../../components/powered-by-affiliation';
import { PageHeader } from '../../components/modals/settings-modal/page-header';
import { usePoweredByBranding } from '../../hooks/usePoweredByBranding';

export const AboutUs = () => {
  const { enabled: poweredByEnabled, clientLogoUrl } = usePoweredByBranding();
  const logoSrc = poweredByEnabled && clientLogoUrl ? clientLogoUrl : domainLogo;
  const logoAlt = poweredByEnabled && clientLogoUrl ? 'Client logo' : domainLogoAlt;

  return (
    <div className="p-6">
      <PageHeader header="About us" />
      <img className="mx-auto mt-6 max-w-[75%]" src={AboutUsImage} alt="about us" />
      <AboutUsText className="font-open-sans pb-12 pt-6" />
      <img src={logoSrc} alt={logoAlt} className="mx-auto h-8 w-auto max-w-[220px] object-contain" />
      {poweredByEnabled ? (
        <div className="mt-6 flex justify-center">
          <PoweredByAffiliation enabled variant="light" align="center" />
        </div>
      ) : null}
    </div>
  );
};
